import { render, staticRenderFns } from "./VMRSCodesComponent.vue?vue&type=template&id=7e3953ef&"
import script from "./VMRSCodesComponent.vue?vue&type=script&lang=js&"
export * from "./VMRSCodesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports